field1 = document.getElementById('field1')
field2 = document.getElementById('field2')
field3 = document.getElementById('field3')
field4 = document.getElementById('field4')

var a = NaN
var b = NaN
var c = NaN
let d = NaN

function updateFields () {

    a = field1.value
    b = field2.value
    c = field3.value
    d = field4.value    

    var emptyField = getEmptyField()
    
    if (emptyField == 'a') {
        field1.value = (c/d) * b
    }

    if (emptyField == 'b') {
        field2.value = a * (d/c)

    }

    if (emptyField == 'c') {
        field3.value = (a/b) * d
    }


    if (emptyField == 'd') {
        field4.value = c * (b/a)
    }
        /*

        a/b = c/d      | * d
        (a/b) * d = c  | / (a/b)
        c * (b/a) = d
        */


}

function getEmptyField() {
    var emptyCounter = 0
    var checkedFields = 0

    function countEmpty(variable) {
        checkedFields += 1
        console.log(checkedFields)
        if (String(variable) == '') {
            emptyCounter += 1
        }
    }

    [a, b, c, d].map(x => countEmpty(x))

    if (emptyCounter == 0) {
        window.location.reload()
    }

    if (emptyCounter > 1 && checkedFields == 4) {
        console.log('more than 1 field empty')
        return false
    }


    
    if (String(a) == '') {
        return 'a'
    }
    else if (String(b) == '') {
        return 'b'
    }

    else if (String(c) == '') {
        return 'c'
    }

    else {
        return 'd'
    }
    


 
}

/* 
if (String(result) != 'Infinity' && String(result) != 'NaN') {
    field3.value = (Math.round(result*1000)/1000)
}

*/